/* eslint-disable camelcase */

export type ApplicationReviewResult = {
  notes?: string
  reviewed?: boolean
}
